import { Box } from '@mui/material';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export function MaxButton({
  field,
  value,
  disabled,
  'data-testid': dataTestId,
  customStyles,
  onAfterSet: onAfterSetCallback,
}: {
  field: string;
  value: number;
  disabled?: boolean;
  'data-testid'?: string;
  customStyles?: React.CSSProperties;
  onAfterSet?: () => void;
}) {
  const form = useFormContext();

  const setMax = useCallback(() => {
    form.setValue(field, value, { shouldValidate: true, shouldDirty: true });
    onAfterSetCallback?.();
  }, [field, value, form, onAfterSetCallback]);

  if (disabled) {
    return null;
  }
  return (
    <Box
      onClick={setMax}
      data-testid={dataTestId}
      style={{
        cursor: 'pointer',
        color: 'blue',
        textDecoration: 'underline',
        fontSize: '11px',
        marginTop: '-22px',
        marginLeft: 'auto',
        marginRight: '5px',
        zIndex: 10,
        ...customStyles,
      }}>
      max
    </Box>
  );
}
